<div class="mat-dialog-header">
  <div class="mat-dialog-title">{{title}}</div>
  <fa-icon (click)="closeDialog()" [icon]="['fas', 'close']"></fa-icon>
</div>
<div mat-dialog-content>
  <ng-container *ngFor="let control of getControlNames(); let i = index">
      <div class="error-message {{i%2 !== 0 ? 'dark-background' : ''}}" [innerHTML]="getDisplayError(control)[1]"></div>
  </ng-container>
</div>
<div mat-dialog-actions align="end" class="modal-dialog-actions">
  <button
    type="button"
    mat-button
    class="modal-cancel-button"
    (click)="closeDialog()">
    {{closeButton | uppercase}}
  </button>
  <button
    *ngIf="confirmButton"
    type="button"
    mat-button
    class="modal-cancel-button"
    (click)="confirmDialog()">
    {{confirmButton | uppercase}}
  </button>
</div>
